import { Observable } from 'rxjs';

export abstract class SessionData {
  // abstract getUserSession(): Observable<UserAuthData>;
  // abstract setUserSession(session: UserAuthData): Observable<boolean>;
  abstract deleteUserSession(): Observable<boolean>;

  abstract setCampusSession(campus: number): Observable<boolean>;
  abstract deleteCampusSession(): Observable<boolean>;
  abstract getCampusSession(): Observable<number>;

  // abstract getBudgetFundCategoryAccountSession(): Observable<Array<any>>;
  // abstract setBudgetFundCategoryAccountSession(account: Array<any>): Observable<boolean>;
  // abstract deleteBudgetFundCategoryAccountSession(): Observable<boolean>;

  // ========== BUDGET FUND CATEGORY ========== 
  abstract getBudgetFundCategoryInputParamSession(): Observable<Array<any>>;
  abstract setBudgetFundCategoryInputParamSession(account: Array<any>): Observable<boolean>;
  abstract deleteBudgetFundCategoryInputParamSession(): Observable<boolean>;

  abstract getBudgetFundCategoryInputTypeAndDescriptionSession(): Observable<Array<any>>;
  abstract setBudgetFundCategoryInputTypeAndDescriptionSession(type_desc: Array<any>): Observable<boolean>;
  abstract deleteBudgetFundCategoryInputTypeAndDescriptionSession(): Observable<boolean>;

  abstract getBudgetFundCategoryDescriptionFunctionSession(): Observable<Array<any>>;
  abstract setBudgetFundCategoryDescriptionFunctionSession(type_desc: Array<any>): Observable<boolean>;
  abstract deleteBudgetFundCategoryDescriptionFunctionSession(): Observable<boolean>;
  // ========================================== 

  // ========== OBLIGATION LIST =============== 
  abstract getObligationInputParamSession(): Observable<Array<any>>;
  abstract setObligationInputParamSession(params: any): Observable<boolean>;
  abstract deleteObligationInputParamSession(): Observable<boolean>;

  // type and description
  abstract getObligationTypeAndDescriptionSession(): Observable<Array<any>>;
  abstract setObligationTypeAndDescriptionSession(account: Array<any>): Observable<boolean>;
  abstract deleteObligationTypeAndDescriptionSession(): Observable<boolean>;
  // ========================================== 

  // ========== expiration date ===============
  abstract setExiprationTime(timestamp: number): Observable<boolean>;
  abstract getExpirationTime(): Observable<any>;
  abstract deleteExpirationTime(): Observable<boolean>;
  // ========================================== 

}
